var map = {
	"./australia.png": "70ea",
	"./austria.png": "419f",
	"./belgium.png": "9edf",
	"./brazil.png": "c4d6",
	"./canada.png": "34bb",
	"./chile.png": "a4a5",
	"./colombia.png": "668f",
	"./denmark.png": "37fe",
	"./error.png": "a5a2",
	"./finland.png": "1b83",
	"./france.png": "829e",
	"./germany.png": "aed3",
	"./ghana.png": "089f",
	"./greece.png": "513c",
	"./india.png": "1152",
	"./ireland.png": "2446",
	"./italy.png": "8520",
	"./japan.png": "2eb0",
	"./latvia.png": "3719",
	"./lithuania.png": "4429",
	"./malta.png": "3a2d",
	"./mauritius.png": "28b1",
	"./new-zealand.png": "f982",
	"./norway.png": "7158",
	"./poland.png": "9c81",
	"./russia.png": "a651",
	"./singapore.png": "0921",
	"./slovakia.png": "3af7",
	"./south-africa.png": "f2ee",
	"./spain.png": "a594",
	"./sweden.png": "00f2",
	"./switzerland.png": "827f",
	"./turkey.png": "dc72",
	"./uk.png": "403c",
	"./ukraine.png": "eca2",
	"./uruguay.png": "0f59",
	"./usa.png": "130f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1c99";